import React from 'react'
import { Box } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import Image from 'next/image'

import styles from './tour-modal.module.scss'

interface TourModalProps {
	open: boolean
	onClose: (e?: any) => void
	children?: React.ReactNode
	compact?: boolean
}

export const TourModal: React.FC<TourModalProps> = ({ open, onClose, children, compact }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth={false}
			className={`${styles.dialog} ${compact ? styles.dialogCompact : ''}`}
		>
			<Image 
				onClick={onClose} 
				className={styles.close} 
				src={'/x-mark.svg'} 
				width={14} 
				height={14} 
				alt={''} 
			/>
			<Box className={compact ? styles.wrapCompact : styles.wrap}>{children}</Box>
		</Dialog>
	)
}

